
/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../../constants";
import { fetchData } from "../../../../helpers";

// GETALLCONTACTUSSECTIONSBYSECTIONNAMEBASEDONCREATOR
// GETALLCONTACTUSSECTIONSBYSECTIONNAMEBASEDONCREATOR


const GETALLCONTACTUSSECTIONSBYSECTIONNAMEBASEDONCREATOR= createAsyncThunk(
  "getAllContactUsSectionsBySectionNameBasedOnCreator/getAllContactUsSectionsBySectionNameBasedOnCreator",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getAllContactUsSectionsBySectionNameBasedOnCreatorSlice = createSlice({
  name: "getAllContactUsSectionsBySectionNameBasedOnCreatorSlice",
  initialState: {
    getAllContactUsSectionsBySectionNameBasedOnCreator: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetAllContactUsSectionsBySectionNameBasedOnCreator: (state) => {
        state.getAllContactUsSectionsBySectionNameBasedOnCreator.loading = false
        state.getAllContactUsSectionsBySectionNameBasedOnCreator.error = false
        state.getAllContactUsSectionsBySectionNameBasedOnCreator.data = []
        state.getAllContactUsSectionsBySectionNameBasedOnCreator.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETALLCONTACTUSSECTIONSBYSECTIONNAMEBASEDONCREATOR.fulfilled, (state, action) => {
      state.getAllContactUsSectionsBySectionNameBasedOnCreator = {
        ...state.getAllContactUsSectionsBySectionNameBasedOnCreator,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLCONTACTUSSECTIONSBYSECTIONNAMEBASEDONCREATOR.pending, (state, action) => {
      state.getAllContactUsSectionsBySectionNameBasedOnCreator = {
        ...state.getAllContactUsSectionsBySectionNameBasedOnCreator,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLCONTACTUSSECTIONSBYSECTIONNAMEBASEDONCREATOR.rejected, (state, action) => {
      state.getAllContactUsSectionsBySectionNameBasedOnCreator = {
        ...state.getAllContactUsSectionsBySectionNameBasedOnCreator,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getAllContactUsSectionsBySectionNameBasedOnCreatorAction = {
    GETALLCONTACTUSSECTIONSBYSECTIONNAMEBASEDONCREATOR,
};

export { getAllContactUsSectionsBySectionNameBasedOnCreatorAction };
export default getAllContactUsSectionsBySectionNameBasedOnCreatorSlice.reducer;
export const {setInitialStateOfgetAllContactUsSectionsBySectionNameBasedOnCreator} = getAllContactUsSectionsBySectionNameBasedOnCreatorSlice.actions
